import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import Header from'../Component/Header'
const Facilities = () => {   
  useEffect(() => {
    document.title = ' Facilities - St. Josephs School Quadian Punjab';  
}, []); 
  return (
     <> 
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Facilities</li>
                 <li>Facilities</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2>Facilities</h2>
                    </div>
                </div>
                <div className="row fac">
                <div class="block"> 
                <div> 
                   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SJCSQP/public/Images/Library.jpg" ><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/Library.jpg" alt="SJCSQP" class="img-fluid" /></a>
                  <h5>  School  Library</h5> 
                </div> 
               <div> 
                   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SJCSQP/public/Images/PhysicsLab.jpg" ><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/PhysicsLab.jpg" alt="SJCSQP" class="img-fluid" /></a>
                  <h5>   Physics Lab</h5> 
                </div> 
                 <div> 
                   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SJCSQP/public/Images/ChemistryLab.jpg" ><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/ChemistryLab.jpg" alt="SJCSQP" class="img-fluid" /></a>
                  <h5>Chemistry Lab </h5> 
                </div> 
                  <div> 
                   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SJCSQP/public/Images/BiologyLab.jpg" ><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/BiologyLab.jpg" alt="SJCSQP" class="img-fluid" /></a>
                  <h5>Biology Lab </h5> 
                </div> 
                 <div> 
                   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SJCSQP/public/Images/ComputerLab.jpg" ><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/ComputerLab.jpg" alt="SJCSQP" class="img-fluid" /></a>
                  <h5>  Computer Lab </h5> 
                </div> 
                 <div> 
                   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SJCSQP/public/Images/AUDITORIUM.jpg" ><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/AUDITORIUM.jpg" alt="SJCSQP" class="img-fluid" /></a>
                  <h5> Auditorium </h5> 
                </div>  
                 <div> 
                   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SJCSQP/public/Images/Transportation.jpg" ><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/Transportation.jpg" alt="SJCSQP" class="img-fluid" /></a>
                  <h5>Transportation </h5> 
                </div> 
             </div>
                </div>  
            </div>  
        </div>
     </>
  )
}

export default Facilities

